const alex = "/_app/immutable/assets/alex.IV3YuqVG.png";
const __vite_glob_0_0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: alex
}, Symbol.toStringTag, { value: "Module" }));
const demo = "/_app/immutable/assets/glimmr-product-diagram.CjXUwnFL.png";
const __vite_glob_0_2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: demo
}, Symbol.toStringTag, { value: "Module" }));
const happyCustomer = "/_app/immutable/assets/happy-customer.CCRBfwB2.png";
const __vite_glob_0_3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: happyCustomer
}, Symbol.toStringTag, { value: "Module" }));
const jordan = "/_app/immutable/assets/jordan.BnQYPCuQ.png";
const __vite_glob_0_7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jordan
}, Symbol.toStringTag, { value: "Module" }));
const mia = "/_app/immutable/assets/mia.CrJbd0lR.png";
const __vite_glob_0_8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mia
}, Symbol.toStringTag, { value: "Module" }));
const riley = "/_app/immutable/assets/riley.5JiLs8gN.png";
const __vite_glob_0_9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: riley
}, Symbol.toStringTag, { value: "Module" }));
export {
  __vite_glob_0_0 as _,
  __vite_glob_0_2 as a,
  __vite_glob_0_3 as b,
  __vite_glob_0_7 as c,
  __vite_glob_0_8 as d,
  __vite_glob_0_9 as e,
  demo as f,
  alex as g,
  happyCustomer as h,
  jordan as j,
  mia as m,
  riley as r
};
